import api from "@/services/api";
import { ENDPOINTS } from "@/constants/endpoints";
import url from "@/helpers/url";
import { cleanObject } from "@/helpers/service";

export default {
  async saveMeeting(form) {
    try {
      const { data } = await api.post(ENDPOINTS.meetings, cleanObject(form));
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },

  async updateMeeting(form, meetingId) {
    if (!meetingId) {
      return Promise.reject("Meeting ID is required");
    }
    try {
      const { data } = await api.patch(
        url(ENDPOINTS.meeting, { id: meetingId }),
        cleanObject(form)
      );
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },

  async confirmMeeting(form, meetingId) {
    if (!meetingId) {
      return Promise.reject("Meeting ID is required");
    }
    try {
      const { data } = await api.patch(
        url(ENDPOINTS.confirm, { meetingId }),
        cleanObject(form)
      );
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async deleteMeetingConfirm(meetingId) {
    if (!meetingId) {
      return Promise.reject("Meeting ID is required");
    }
    try {
      await api.delete(url(ENDPOINTS.confirm, { meetingId }));
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async deleteMeetingAgendaItem(meetingId, itemId) {
    if (!meetingId) {
      return Promise.reject("Meeting ID is required");
    }
    try {
      await api.delete(url(ENDPOINTS.agendaItem, { meetingId, itemId }));
    } catch (e) {
      return Promise.reject(e);
    }
  },

  async deleteMeeting(meetingId) {
    return await api.delete(url(ENDPOINTS.meeting, { id: meetingId }));
  },

  async resendMeetingReminder(meetingId) {
    await api.post(url(ENDPOINTS.resend_meeting, { meetingId }));
  },

  async getMeetings(cooperativeId) {
    try {
      const { data } = await api.get(ENDPOINTS.meetings, {
        params: { apartment_groups: 1, cooperative_id: cooperativeId },
      });
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },

  async getMeeting(meetingId) {
    try {
      const { data } = await api.get(
        url(ENDPOINTS.meeting, { id: meetingId }),
        {
          params: { apartment_groups: 1 },
        }
      );
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },

  async deleteMeetingItemFile(meetingId, itemId, fileId) {
    try {
      await api.delete(
        url(ENDPOINTS.agendaItemFile, { meetingId, itemId, fileId })
      );
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  },

  async deleteMeetingFile(meetingId, fileId) {
    try {
      await api.delete(url(ENDPOINTS.meetingFile, { meetingId, fileId }));
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  },
};
